import {precacheAndRoute as workbox_precaching_precacheAndRoute} from '/home/pinusc/dev/tea-timer/node_modules/workbox-precaching/precacheAndRoute.mjs';/**
 * Welcome to your Workbox-powered service worker!
 *
 * You'll need to register this file in your web app.
 * See https://goo.gl/nhQhGp
 *
 * The rest of the code is auto-generated. Please don't update this file
 * directly; instead, make changes to your Workbox build configuration
 * and re-run your build process.
 * See https://goo.gl/2aRDsh
 */








self.addEventListener('message', (event) => {
  if (event.data && event.data.type === 'SKIP_WAITING') {
    self.skipWaiting();
  }
});




/**
 * The precacheAndRoute() method efficiently caches and responds to
 * requests for URLs in the manifest.
 * See https://goo.gl/S9QRab
 */
workbox_precaching_precacheAndRoute([
  {
    "url": "bell.mp3",
    "revision": "a804ebd93b1d23ccb7532a126d60bf0c"
  },
  {
    "url": "css/reset.css",
    "revision": "8441ced013cf3e7dd74b83a7f05df689"
  },
  {
    "url": "css/style.css",
    "revision": "66399a107ad66c399c894141c80c90eb"
  },
  {
    "url": "favicon.ico",
    "revision": "461a7280bcc295c2d50ac5dcadfda59b"
  },
  {
    "url": "icon/clock.ico",
    "revision": "065c2710a5b82f9983e608c8ff88a49a"
  },
  {
    "url": "icon/clock.png",
    "revision": "788ef2755af943f0efb256e0e38af384"
  },
  {
    "url": "icon/clock.svg",
    "revision": "ea3f87d138d7aecf39f43afa7707da47"
  },
  {
    "url": "icon/clock512.png",
    "revision": "e780cdbe062668f7a17fdf3bc8db878f"
  },
  {
    "url": "icon/kermit-drinking-tea.svg",
    "revision": "fc43ec373010804aff20f3c80eecf8e3"
  },
  {
    "url": "icon/kermit.png",
    "revision": "5450e397e5eb1873ba645163db532295"
  },
  {
    "url": "icon/kermit512.png",
    "revision": "c4d03418757e409d3ddddc6d24d54f3c"
  },
  {
    "url": "index.html",
    "revision": "77a57c1128560dd2cf09646973a67a26"
  },
  {
    "url": "manifest.webmanifest",
    "revision": "581db080acac48c9054e5cfccf4501fb"
  },
  {
    "url": "raleway.ttf",
    "revision": "580d0778ad254335be45bf58bb449f43"
  },
  {
    "url": "success.mp3",
    "revision": "3a973fdd2a1dadda4f174af0173da803"
  },
  {
    "url": "svg-bak/bell-off.svg",
    "revision": "bc81ff68da34b0bb22e97ff9d84a1592"
  },
  {
    "url": "svg-bak/bell.svg",
    "revision": "86facaccbf1a6c7def3651ff56008134"
  },
  {
    "url": "svg-bak/feather-sprite.svg",
    "revision": "3a8573e64abfb092670d6b5c359b124f"
  },
  {
    "url": "svg-bak/moon.svg",
    "revision": "5947fcb1f570d687a211ea0bc3f8e2c5"
  },
  {
    "url": "svg-bak/pause.svg",
    "revision": "7375c856ac1d6249eb005fb9faea66cb"
  },
  {
    "url": "svg-bak/play.svg",
    "revision": "34df31112e5959a1e5c0abf66851818d"
  },
  {
    "url": "svg-bak/settings.svg",
    "revision": "0101be31b8a85078eaace8ca2d865a20"
  },
  {
    "url": "svg-bak/square.svg",
    "revision": "e3aa28b61ad5475db3657096d1f85820"
  },
  {
    "url": "svg-bak/sun.svg",
    "revision": "eafa19dde8ac0c4fda486e22a2ae2616"
  },
  {
    "url": "svg-bak/x.svg",
    "revision": "b0200bf7cbbb26c32989e7a0e4d19eef"
  },
  {
    "url": "svg/arrow-left.svg",
    "revision": "1d9d9734c6892da48c9880d96b7bef42"
  },
  {
    "url": "svg/bell-off.svg",
    "revision": "b1a7acb8ee6624ada10deac6c55cc14d"
  },
  {
    "url": "svg/bell.svg",
    "revision": "23b4f719aa5acf381f8d9b062808851f"
  },
  {
    "url": "svg/moon.svg",
    "revision": "2cd5d46ac9117f424cdd180135d36707"
  },
  {
    "url": "svg/pause.svg",
    "revision": "8287b08deee8cbd94fb4e54fa9931361"
  },
  {
    "url": "svg/play.svg",
    "revision": "d7a57964d5d59c8521840796e56cfb69"
  },
  {
    "url": "svg/settings.svg",
    "revision": "5ee7fe0043f7dd555df4ba75b29f5c8f"
  },
  {
    "url": "svg/square.svg",
    "revision": "bac879d00342f8f5e5281f303f968127"
  },
  {
    "url": "svg/sun.svg",
    "revision": "d3a9dd6bfd74f802135949e22cb896ee"
  },
  {
    "url": "svg/x.svg",
    "revision": "41c11ae3f4d25a4d90f25bdbc2f9a726"
  },
  {
    "url": "js/app.js",
    "revision": "79e67b46476bfab304d83d3134655c6d"
  }
], {
  "ignoreURLParametersMatching": [/^utm_/, /^fbclid$/]
});








